// @flow

import type {Action} from '../../types';
import type {TableStore} from '../types';

import moment from 'moment';
import {
  SET_COUNT,
  SET_DISPUTES,
  SET_FETCHING,
  SET_FILTER,
  SET_PAGINATION_CURRENT,
  SET_SORT_CURRENT
} from '../actions/table';

const initialState: TableStore = {
  fetching: false,
  filter: {
    inDateBegin: moment()
      .subtract(3, 'months')
      .toDate(),
    inDateFinish: moment()
      .subtract(1, 'days')
      .toDate(),
    project: [],
    instance: [],
    reason: [],
    status: []
  },
  row: {
    count: 0,
    disputes: []
  },
  currentPage: 1,
  sort: {
    field: '',
    dir: ''
  }
};

export default (state: TableStore = initialState, action: Action) => {
  switch (action.type) {
    case SET_PAGINATION_CURRENT:
      return {
        ...state,
        currentPage: action.payload
      };
    case SET_FILTER:
      return {
        ...state,
        filter: action.payload || initialState.filter
      };
    case SET_FETCHING:
      return {
        ...state,
        fetching: action.payload
      };
    case SET_COUNT:
      return {
        ...state,
        row: {
          ...state.row,
          count: action.payload
        }
      };
    case SET_DISPUTES:
      return {
        ...state,
        row: {
          ...state.row,
          disputes: action.payload
        }
      };
    case SET_SORT_CURRENT:
      return {
        ...state,
        sort: action.payload || initialState.sort
      };
    default:
      return state;
  }
};
